import { render } from "./CodeBoxes.vue?vue&type=template&id=83ff229c&scoped=true"
import script from "./CodeBoxes.vue?vue&type=script&lang=js"
export * from "./CodeBoxes.vue?vue&type=script&lang=js"

import "./CodeBoxes.vue?vue&type=style&index=0&id=83ff229c&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83ff229c"]])

export default __exports__